export const pluginPrefix = 'PLUGIN:HP_PLUGIN:';
export const SET_PURCHASE_ORDER = `${pluginPrefix}SET_PURCHASE_ORDER`;
export const SET_MULTIPLE_DOCUMENTS = `${pluginPrefix}SET_MULTIPLE_DOCUMENTS`;
